import { createSlice } from "@reduxjs/toolkit";

import { getBankInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  currentData: getBankInformationRes;
  formData: getBankInformationRes;
  changedData: {
    [key: string]: any;
  };
}

const initialState: InitialState = {
  currentData: { accountBankCode: "", bankName: "" },
  formData: { accountBankCode: "", bankName: "" },
  changedData: undefined,
};

const formEditBankInformationSlice = createSlice({
  name: "editBankInformation",
  initialState,
  reducers: {
    updateFormEditBankInformation: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    updateBankInformationCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    updateBankInformationChangedData: (state, action) => {
      state.changedData = action.payload;
    },
    resetFormEditBankInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormEditBankInformation,
  updateBankInformationCurrentData,
  updateBankInformationChangedData,
  resetFormEditBankInformation,
} = formEditBankInformationSlice.actions;

export default formEditBankInformationSlice.reducer;
